import produce from 'immer';

import {
  READ_ALL_NOTIFICATION_FAILURE,
  READ_ALL_NOTIFICATION_START,
  READ_ALL_NOTIFICATION_SUCCESS
} from '@redux/actions/cpNotificationPopup/readAllNotification/types';

const initialStates = {
  isLoading: false,
  error: null,
  readNotificationResponse: null
};

const readAllNotificationReducer = (state = initialStates, action) =>
  produce(state, (draft) => {
    switch (action.type) {
    case READ_ALL_NOTIFICATION_START:
      draft.isLoading = true;

      draft.error = null;
      break;

    case READ_ALL_NOTIFICATION_SUCCESS:
      draft.isLoading = false;

      draft.readNotificationResponse = action.payload;
      break;

    case READ_ALL_NOTIFICATION_FAILURE:
      draft.isLoading = false;

      draft.error = action.payload;
      break;
    }

    return draft;
  });

export default readAllNotificationReducer;
